import React, { useState, useEffect, forwardRef  } from "react";
import "../styles/PricingPlans.css";
import { Link } from "react-router-dom";
import { UserCircle } from 'lucide-react';
import { PlusCircle } from "lucide-react";
import { Edit } from "lucide-react";
import { Search } from "lucide-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

const API_URL = "https://shubhjiwan.co.in/ShubhJiwan_backend11/profile_plans.php";
const EDIT_API_URL = "https://shubhjiwan.co.in/ShubhJiwan_backend11/profile_management.php";


// Plan details including duration info
const plans = [
  { id: 1, name: "Gold Plan", price: "₹ 3500", duration: "6 Months" },
  { id: 2, name: "Platinum Plan", price: "₹ 4500", duration: "1 Year" },
  { id: 3, name: "Kohinoor Plan", price: "₹ 5000", duration: "Lifetime" },
];

const PricingPlans = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchDate, setSearchDate] = useState(""); 
  const [editingUser, setEditingUser] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [deletingUser, setDeletingUser] = useState(null); // Track user to be deleted
  const [photoPreview, setPhotoPreview] = useState(null);
  const [photoFile, setPhotoFile] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);

  const CustomInput = forwardRef(
    ({ value, onClick, placeholder, clearDate }, ref) => (
      <div
        className="custom-input-wrapper"
        onClick={onClick}
        ref={ref}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "10px",
          border: "2px solid #666",
          borderRadius: "8px",
          cursor: "pointer",
          width: "220px",
          fontSize: "16px",
          backgroundColor: "#fff",
        }}
      >
        <input
          value={value}
          onChange={() => {}}
          placeholder={placeholder}
          style={{
            border: "none",
            outline: "none",
            flex: 1,
            fontSize: "16px",
            backgroundColor: "transparent",
          }}
          readOnly
        />
        {value
          ? (
            <FontAwesomeIcon
              icon={faTimesCircle}
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation();  // prevent calendar opening
                clearDate();
              }}
            />
          )
          : (
            <FontAwesomeIcon
              icon={faCalendarAlt}
            />
          )
        }
      </div>
    )
  );


  useEffect(() => {
    fetchUsers();
  }, []);


const handleEdit = async (user) => {
  try {
    const response = await fetch(`${EDIT_API_URL}?id=${user.id}`);
    const data = await response.json();
    
    if (data.success) {
      setEditingUser(user.id);
      setEditForm({ ...data.profile });
      setPhotoPreview(data.profile.photo); // Set preview when opening form
      setPhotoFile(null); // Reset file
    } else {
      alert("Failed to fetch profile details.");
    }
  } catch (error) {
    console.error("Error fetching profile details:", error);
  }
};



    // Handle Input Change
    const handleChange = (e) => {
      setEditForm({ ...editForm, [e.target.name]: e.target.value });
    };

    const handleSave = async () => {
      try {
        if (photoFile) {
          const formData = new FormData();
          Object.entries(editForm).forEach(([key, value]) => {
            formData.append(key, value);
          });
          formData.append("photoFile", photoFile); // attach image
    
          await fetch(EDIT_API_URL, {
            method: "POST", // must be POST when uploading image
            body: formData,
          });
        } else {
          await fetch(EDIT_API_URL, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(editForm),
          });
        }
    
        fetchUsers(); // reload after saving
        setEditingUser(null);
        setPhotoFile(null);
        setPhotoPreview(null);
      } catch (error) {
        console.error("Error saving user:", error);
      }
    };
    
    
    const handleFileChange = (e) => {
      const file = e.target.files[0];
      if (file) {
        setPhotoFile(file);
        setPhotoPreview(URL.createObjectURL(file));
      }
    };
  

  // Open Delete Confirmation
  const confirmDelete = (user) => {
    setDeletingUser(user);
  };

  // Handle Delete User
  const handleDelete = async () => {
    try {
      await fetch(EDIT_API_URL, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: deletingUser.id }),
      });
      fetchUsers();
      setDeletingUser(null);
    } catch (error) {
      console.error("Error deleting user:", error);
    }
  };


  const fetchUsers = async () => {
    try {
      const response = await fetch(API_URL);
      const data = await response.json();
      setUsers(data);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
console.log("pricing plans", users);

  const handlePlanSelect = async (userId, planId) => {
    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id: userId, plan_id: planId }),
      });

      const result = await response.json();

      if (result.success) {
        // Update state with new plan and expiry
        setUsers((prevUsers) =>
          prevUsers.map((user) =>
            user.id === userId
              ? { ...user, plan_id: planId, plan_expiry_date: result.expiry_date }
              : user
          )
        );
      } else {
        alert("Failed to update plan");
      }
    } catch (error) {
      console.error("Error updating plan:", error);
    }
  };

  // Check if a plan is currently active for the user
  const isPlanActive = (expiryDate) => {
    if (!expiryDate) return false;
    const today = new Date();
    const expiry = new Date(expiryDate);
    return expiry >= today;
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
    if (date) {
      const formatted = date.toISOString().split("T")[0]; // 'yyyy-mm-dd'
      setSearchDate(formatted);
    } else {
      setSearchDate("");
    }
  };
    // Reset search fields (including date search)
    const handleReset = () => {
      setSearchTerm("");
      setSearchDate("");
      setSelectedDate(null);
    };
  
  // Filter Users (including filter by created_at date)
  const filteredUsers = users.filter((user) => {
    if (!user.created_at) return false;
  
    // Extract only the date part (e.g., "2025-05-20" from "2025-05-20 12:34:56")
    const userDateOnly = user.created_at.split(" ")[0];
  
    let selectedDateOnly = null;
    if (selectedDate) {
      const yyyy = selectedDate.getFullYear();
      const mm = String(selectedDate.getMonth() + 1).padStart(2, "0");
      const dd = String(selectedDate.getDate()).padStart(2, "0");
      selectedDateOnly = `${yyyy}-${mm}-${dd}`; // ✅ Fixed line
    }
  
    const dateMatch = selectedDateOnly
      ? userDateOnly === selectedDateOnly
      : true;
  
    const nameMatch = searchTerm
      ? user.name.toLowerCase().includes(searchTerm.toLowerCase())
      : true;
  
    return dateMatch && nameMatch;
  });

  return (
    <div className="pending-requests">
      <h2 className="flex items-center gap-2">
            <UserCircle className="w-6 h-6" /> Profile Management
        </h2>

{/* Search Bar */}
<div className={`search-container ${searchTerm ? "typing" : ""}`}>
  <Search size={20} className="search-icon" />
  <input
    type="text"
    placeholder="Search by name..."
    className="search-bar"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
  />
</div>

      {/* Date Search Input */}
      <div className="search-date-container">
    <div style={{ padding: "20px" }}>
      <DatePicker
        selected={selectedDate}
        onChange={handleDateChange}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        dateFormat="yyyy-MM-dd"
        placeholderText="Select date"
        customInput={
          <CustomInput clearDate={() => setSelectedDate(null)} />
        }
        isClearable={false}  
      />
    </div>
      <button className="refresh-btn" onClick={handleReset}>
    🔄 Refresh
</button>

      </div>

        {/* Add Profile Button */}
      <div className="top-bar">
      <Link to="/admin/add-profile" className="add-profile-btn">
    <PlusCircle className="icon" /> Add Profile
</Link>

      </div>

      <table className="profile-table">
        <thead>
          <tr>
          <th>Photo</th>
            <th>Name</th>
            <th>Current Plan</th>
            <th>Transaction ID</th>
            <th>Payment Method</th>
            <th>Plan Expiry</th>
            <th>Choose Plan</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
        {filteredUsers.length > 0 ? (
  filteredUsers.map((user) => {
    const planActive = isPlanActive(user.plan_expiry_date);
    return (
      <tr key={user.id}>
        <td>
          <img
            src={user.photo || "default.jpg"}
            alt="User"
            className="user-img"
          />
        </td>
        <td>{user.name}</td>
        <td>
          {plans.find((p) => p.id === parseInt(user.plan_id))?.name || "None"}
        </td>
        <td>{user.transaction_id}</td>
                  <td>{user.payment_method}</td>
        <td>
          {user.plan_expiry_date
            ? new Date(user.plan_expiry_date).toLocaleDateString()
            : "N/A"}
        </td>
        <td>
          {plans.map((plan) => (
            <button
              key={plan.id}
              className={`plan-btn ${
                user.plan_id === plan.id && planActive ? "active" : ""
              }`}
              onClick={() => handlePlanSelect(user.id, plan.id)}
              disabled={planActive}
            >
              {plan.name}
            </button>
          ))}
        </td>
        <td>
  <div className="flex gap-3">
    <button className="edit-btn flex items-center gap-1 px-3 py-1 rounded" onClick={() => handleEdit(user)}>
      <span className="icon transition-transform duration-200">✏️</span> Edit
    </button>
    <button className="delete-btn flex items-center gap-1 px-3 py-1 rounded" onClick={() => confirmDelete(user)}>
      <span className="icon transition-transform duration-200">🗑️</span> Delete
    </button>
  </div>
</td>


        {/* <td>
          <button className="edit-btn" onClick={() => handleEdit(user)}>
            <span className="icon">✏️</span> Edit
          </button>
          <button className="delete-btn" onClick={() => confirmDelete(user)}>
            <span className="icon">🗑️</span> Delete
          </button>
        </td> */}
      </tr>
    );
  })
) : (
  <tr>
  <td colSpan="6" className="no-results">
    No results found.
  </td>
</tr>

)}

        </tbody>
      </table>
      {editingUser && (
  <div className="edit-form-overlay">
    <div className="edit-form">
    <h3>
  <Edit className="icon" size={20} style={{ marginRight: "0.5rem" }} />
  Edit User
</h3>
      <div className="form-grid">
  <div>
    <label>Name:</label>
    <input type="text" name="name" value={editForm.name} onChange={handleChange} />
  </div>
  <div className="form-group full-width">
      <label className="mt-2"> Upload Photo:</label>
      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        className="upload-input"
      />

      {photoPreview && (
        <div className="photo-preview mt-2">
          <img src={photoPreview} alt="Preview" className="user-img" />
        </div>
      )}
    </div>

  <div>
    <label>Date of Birth:</label>
    <input type="date" name="date_of_birth" value={editForm.date_of_birth} onChange={handleChange} />
  </div>

  <div>
    <label>Annual Income:</label>
    <select name="annual_income" value={editForm.annual_income} onChange={handleChange}>
      <option value="Select">Select Option</option>
      <option value="1.5 Lakh to 4 Lakh">1.5 Lakh to 4 Lakh</option>
      <option value="4 Lakh to 8 Lakh">4 Lakh to 8 Lakh</option>
      <option value="8 Lakh to 10 Lakh">8 Lakh to 10 Lakh</option>
      <option value="Above 10 Lakh">Above 10 Lakh </option>
    </select>
  </div>

  <div>
    <label>Gender:</label>
    <select name="gender" value={editForm.gender} onChange={handleChange}>
      <option value="Select">Select Option</option>
      <option value="Male">Male</option>
      <option value="Female">Female</option>
      <option value="Other">Other</option>
    </select>
  </div>

  <div>
    <label>Marital Status:</label>
    <select name="marital_status" value={editForm.marital_status} onChange={handleChange}>
      <option value="Select">Select Option</option>
      <option value="Single">Single</option>
      <option value="Married">Married</option>
      <option value="Divorced">Divorced</option>
      <option value="Widowed">Widowed</option>
    </select>
  </div>

  <div>
    <label>Caste:</label>
    <input type="text" name="caste" value={editForm.caste} onChange={handleChange} />
  </div>

  <div>
    <label>City:</label>
    <input type="text" name="city" value={editForm.city} onChange={handleChange} />
  </div>

  <div>
    <label>Height (in cm):</label>
    <input type="number" step="0.1" name="height" value={editForm.height} onChange={handleChange} />
  </div>

  <div>
    <label>Education:</label>
    <input type="text" name="education" value={editForm.education} onChange={handleChange} />
  </div>

  <div>
    <label>Occupation:</label>
    <input type="text" name="occupation" value={editForm.occupation} onChange={handleChange} />
  </div>

  <div>
    <label>Religion:</label>
    <input type="text" name="religion" value={editForm.religion} onChange={handleChange} />
  </div>

  <div>
    <label>Created At:</label>
    <input type="text" name="created_at" value={editForm.created_at} readOnly />
  </div>

  <div className="full-width">
    <label>About:</label>
    <textarea name="about" value={editForm.about} onChange={handleChange} />
  </div>

  <div className="full-width">
    <label>Looking For:</label>
    <textarea name="looking_for" value={editForm.looking_for} onChange={handleChange} />
  </div>
</div>

      <div className="button-group">
      <button className="save-btn" onClick={handleSave}>
  💾 Save
</button>
<button className="cancel-btn" onClick={() => setEditingUser(null)}>
  ❌ Cancel
</button>

      </div>
    </div>
  </div>
)}

      {/* Delete Confirmation Modal */}
      {deletingUser && (
        <div className="delete-form-overlay">
          <div className="delete-form">
            <h3>Delete User</h3>
            <p>Are you sure you want to delete <strong>{deletingUser.name}</strong>?</p>
            <div className="button-group">
              <button className="delete-confirm-btn" onClick={handleDelete}>Yes, Delete</button>
              <button className="cancel-btn" onClick={() => setDeletingUser(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default PricingPlans;
